import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./profile-page.m.css";
import { Link } from "@quintype/components";
import { setIsLogin, setUserDetails } from "../../store/actions";
import { get } from "lodash";
import { googleLogout } from "@react-oauth/google";
import Close from "../../atoms/other-icons/Close";
import DownArrow from "../../atoms/other-icons/DownArrow";
import Signout from "../../atoms/other-icons/Signout";
import { addLogoutToDataLayer } from "../../helper/datalayer-utils";
import Arrow from "../../atoms/other-icons/Arrow";
import EditIcon from "../../atoms/other-icons/edit-icon";
import Calender from "../../atoms/other-icons/Calender";
import FillDownArrow from "../../atoms/other-icons/FillDownArrow";
import LocationPinIcon from "../../atoms/other-icons/location-pin-icon";
import CityIcon from "../../atoms/other-icons/city-icon";
import TickIcon from "../../atoms/other-icons/tick-icon";
import BirthDatePicker from "./date-picker/index";
import GenderIcon from "../../atoms/other-icons/gender";
import User from "../../atoms/other-icons/User";
import PhoneIcon from "../../atoms/other-icons/Phone";
import MailIcon from "../../atoms/other-icons/Mail-icon";
import NewUserIcon from "../../atoms/other-icons/New-User-icon";
import EmptyCalenderIcon from "../../atoms/other-icons/EmptyCalender";
import { Snackbar } from "../../common/snackbar";
import {
  putUserDetails,
  sendChangeEmailOtp,
  sendChangePhoneOtp,
  verifySsoCode,
  getUserDetails,
  addTokensToLocalStorage,
  getEpaperEditions,
  getEpaperPreferences,
  updateEpaperPreferences,
  getAccessToken,
  getRefreshToken,
  clearAuthCookies
} from "../../helper/utils";
import MySubscription from "../../atoms/my-account/my-subscription";

export const TimerIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    className={props.className}
  >
    <path
      d="M20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20V22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22V20C15.9706 20 20 15.9706 20 11Z"
      fill="#0091AC"
    />
    <path
      d="M11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20V22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0V2Z"
      fill="#999999"
    />
  </svg>
);

export const SpinnerIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    className={props.className}
  >
    <path
      d="M4.08333 12.8083C3.27222 12.4583 2.56389 11.9806 1.95833 11.375C1.35278 10.7694 0.875 10.0611 0.525 9.25C0.175 8.43889 0 7.575 0 6.65833C0 5.74167 0.175 4.88056 0.525 4.075C0.875 3.26944 1.35278 2.56389 1.95833 1.95833C2.56389 1.35278 3.27222 0.875 4.08333 0.525C4.89444 0.175 5.75556 0 6.66667 0C6.85556 0 7.01389 0.0638889 7.14167 0.191667C7.26944 0.319444 7.33333 0.477778 7.33333 0.666667C7.33333 0.855555 7.26944 1.01389 7.14167 1.14167C7.01389 1.26944 6.85556 1.33333 6.66667 1.33333C5.18889 1.33333 3.93056 1.85278 2.89167 2.89167C1.85278 3.93056 1.33333 5.18889 1.33333 6.66667C1.33333 8.14444 1.85278 9.40278 2.89167 10.4417C3.93056 11.4806 5.18889 12 6.66667 12C8.14444 12 9.40278 11.4806 10.4417 10.4417C11.4806 9.40278 12 8.14444 12 6.66667C12 6.47778 12.0639 6.31944 12.1917 6.19167C12.3194 6.06389 12.4778 6 12.6667 6C12.8556 6 13.0139 6.06389 13.1417 6.19167C13.2694 6.31944 13.3333 6.47778 13.3333 6.66667C13.3333 7.57778 13.1583 8.43889 12.8083 9.25C12.4583 10.0611 11.9806 10.7694 11.375 11.375C10.7694 11.9806 10.0639 12.4583 9.25833 12.8083C8.45278 13.1583 7.59167 13.3333 6.675 13.3333C5.75833 13.3333 4.89444 13.1583 4.08333 12.8083Z"
      fill="white"
    />
  </svg>
);

const formatPhoneNumber = (num) => {
  if (!num) return "";
  const strNum = String(num);
  if (strNum.startsWith("+91") && strNum.length === 13) {
    return `+91 ${strNum.substring(3)}`;
  }
  return strNum;
};

const ProfilePage = ({ data }) => {
  const dispatch = useDispatch();
  const [isDropdownCollapsed, setIsDropdownCollapsed] = useState("myprofile");
  const [redirectUrl, setRedirectUrl] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const storeUserDetails = useSelector((state) => get(state, ["user", "user"], {}));
  const userdetails = storeUserDetails;
  const isGoogleUser =
    userdetails?.metadata?.login_method === "google_login" || userdetails?.metadata?.login_method === "google";
  const ssoEndpoint = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "sso_endpoint"], null)
  );

  const [selectedButton, setSelectedButton] = useState(1);
  const PAYMENT_PROCESSING_STATE_KEY = "subscribe_payment_processing_state";
  const SHOW_SUPPORT_STRIP_ON_REDIRECT_KEY = "show_support_strip_on_redirect";

  useEffect(() => {
    if (typeof window !== "undefined" && window.location.hash === "#subscription") {
      setSelectedButton(2);
    }
  }, []);
  const [gender, setGender] = useState("male");
  const [isEpaperOpen, setIsEpaperOpen] = useState(false);
  const [selectedEpaper, setSelectedEpaper] = useState("");
  const [selectedEpaperId, setSelectedEpaperId] = useState("");
  const [editionList, setEditionList] = useState([]);
  const [isEpaperLoading, setIsEpaperLoading] = useState(true);

  useEffect(() => {
    // Fetch editions and user preferences simultaneously
    Promise.all([getEpaperEditions(), getEpaperPreferences()])
      .then(([editionsRes, prefRes]) => {
        // Flatten editions
        const flatEditions = [];
        if (editionsRes && editionsRes[0] && editionsRes[0].editions) {
          editionsRes[0].editions.forEach((ed) => {
            flatEditions.push({ id: ed.edition_number, name: ed.edition_name });
          });
        }
        setEditionList(flatEditions);

        // Pre-fill user's previously saved preference
        let hasMatchedEdition = false;
        // Check both preferredEditionId and pv_preferred_edition_id just in case
        const savedPrefId = prefRes?.pv_preferred_edition_id || prefRes?.preferredEditionId;

        if (savedPrefId) {
          const matchedEdition = flatEditions.find((ed) => String(ed.id) === String(savedPrefId));
          if (matchedEdition) {
            setSelectedEpaper(matchedEdition.name);
            setSelectedEpaperId(matchedEdition.id);
            hasMatchedEdition = true;
          }
        }

        // Default to edition 4 (Bengaluru Nagar) if no preference is found
        if (!hasMatchedEdition) {
          const defaultEdition = flatEditions.find((ed) => String(ed.id) === "4");
          if (defaultEdition) {
            setSelectedEpaper(defaultEdition.name);
            setSelectedEpaperId(defaultEdition.id);
          }
        }
      })
      .finally(() => {
        setIsEpaperLoading(false);
      });
  }, []);

  const dropdownRef = useRef(null);
  const [birthDate, setBirthDate] = useState(null);
  const [savedDob, setSavedDob] = useState(null);
  const [dobDone, setDobDone] = useState(true);
  const [isUpdatingDob, setIsUpdatingDob] = useState(false);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [dobError, setDobError] = useState(false);
  const [dobErrorMessage, setDobErrorMessage] = useState("");

  // Mobile State
  const [mobileNumber, setMobileNumber] = useState("");
  const [savedMobile, setSavedMobile] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [timer, setTimer] = useState(30);
  const [otpValue, setOtpValue] = useState("");
  const [otpError, setOtpError] = useState(false);
  const [mobileError, setMobileError] = useState(false);
  const [mobileErrorMessage, setMobileErrorMessage] = useState("");
  const [otpVerified, setOtpVerified] = useState(true);
  const [isVerifying, setIsVerifying] = useState(false);

  // Name State
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [savedName, setSavedName] = useState("");
  const [nameDone, setNameDone] = useState(true);
  const [isUpdatingName, setIsUpdatingName] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [nameErrorMessage, setNameErrorMessage] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [savedDisplayName, setSavedDisplayName] = useState("");
  const [displayNameDone, setDisplayNameDone] = useState(true);
  const [isUpdatingDisplayName, setIsUpdatingDisplayName] = useState(false);

  // Email State
  const [email, setEmail] = useState("");
  const [savedEmail, setSavedEmail] = useState("");
  const [emailOtpSent, setEmailOtpSent] = useState(false);
  const [emailTimer, setEmailTimer] = useState(30);
  const [emailOtpValue, setEmailOtpValue] = useState("");
  const [emailOtpError, setEmailOtpError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  const [emailOtpVerified, setEmailOtpVerified] = useState(true);
  const [isVerifyingEmail, setIsVerifyingEmail] = useState(false);

  // Auth Session for SSO
  const [authSessionInfo, setAuthSessionInfo] = useState({ preAuthSessionId: null, deviceId: null });

  const isNameChanged = firstName !== savedName;
  const isNameUpdateDisabled =
    !isNameChanged || firstName.trim().length < 2 || /^\d+$/.test(firstName.trim()) || isUpdatingName;
  const isSendOtpDisabled = mobileNumber === savedMobile || !/^\d{10}$/.test(mobileNumber);
  const isSendEmailOtpDisabled = email === savedEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleNameBlur = () => {
    if (firstName) {
      setFirstName(firstName.trim());
    }
    if (firstName && (firstName.trim().length < 2 || /^\d+$/.test(firstName.trim()))) {
      setNameError(true);
      setNameErrorMessage("Please enter at least 2 characters.");
    } else {
      setNameError(false);
    }
  };

  const handleMobileBlur = () => {
    if (!mobileNumber || mobileNumber.trim().length === 0) {
      setMobileError(false);
      setMobileErrorMessage("");
    } else if (!/^\d{10}$/.test(mobileNumber)) {
      setMobileError(true);
      setMobileErrorMessage("Enter a valid 10-digit indian mobile number");
    } else {
      setMobileError(false);
      setMobileErrorMessage("");
    }
  };

  const handleEmailBlur = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || email.trim().length === 0) {
      setEmailError(false);
      setEmailErrorMessage("");
    } else if (!emailRegex.test(email)) {
      setEmailError(true);
      setEmailErrorMessage("Invalid email address.");
    } else {
      setEmailError(false);
      setEmailErrorMessage("");
    }
  };

  // Timers
  useEffect(() => {
    let interval;
    if (otpSent && timer > 0) {
      interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    }
    return () => clearInterval(interval);
  }, [otpSent, timer]);

  useEffect(() => {
    let interval;
    if (emailOtpSent && emailTimer > 0) {
      interval = setInterval(() => setEmailTimer((prev) => prev - 1), 1000);
    }
    return () => clearInterval(interval);
  }, [emailOtpSent, emailTimer]);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const searchQuery = window.location.search;
    const accessTokenIndex = searchQuery.indexOf("?access_token");
    const output = accessTokenIndex !== -1 ? searchQuery.substring(accessTokenIndex) : searchQuery;

    const searchParams = new URLSearchParams(output);
    const access_token = searchParams.get("access_token");
    const refresh_token = searchParams.get("refresh_token");

    const userLocalStorage = localStorage.getItem("user");
    const stored_access_token = getAccessToken();
    const stored_refresh_token = getRefreshToken();

    if (stored_refresh_token && stored_access_token) {
      dispatch(setIsLogin(true));
    }

    if (access_token && refresh_token) {
      addTokensToLocalStorage(access_token, refresh_token);

      getUserDetails()
        .then((data) => {
          if (data?.status === 401) {
            localStorage.removeItem("access_token");
            localStorage.removeItem("refresh_token");
            localStorage.removeItem("user");
            localStorage.removeItem("commentsToken");

            googleLogout();

            let redirectUrl = window.location.origin + "/";
            if (document.referrer && document.referrer.includes(window.location.origin)) {
              redirectUrl = document.referrer;
            }
            window.location.href = `${ssoEndpoint}/auth/logout?redirectUrl=${encodeURIComponent(redirectUrl)}`;
          } else {
            sessionStorage.setItem("skip_auth_tracking", "true");

            dispatch(setIsLogin(true));
            dispatch(setUserDetails(data || {}));

            localStorage.setItem("user", JSON.stringify(data));

            const searchParam = accessTokenIndex !== -1 ? searchQuery.substring(0, accessTokenIndex) : searchQuery;

            window.history.replaceState({}, "", window.location.pathname + searchParam);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (stored_access_token && stored_refresh_token) {
      if (userLocalStorage && userLocalStorage !== "undefined") {
        try {
          const parsedUser = JSON.parse(userLocalStorage);
          if (parsedUser && typeof parsedUser === "object") {
            dispatch(setUserDetails(parsedUser));
          }
        } catch (e) {
          console.error("Profile Page Error: Failed to parse user from local storage.", e);
        }
      }

      getUserDetails()
        .then((data) => {
          if (data?.status === 401) {
            localStorage.removeItem("access_token");
            localStorage.removeItem("refresh_token");
            localStorage.removeItem("user");
            localStorage.removeItem("commentsToken");

            googleLogout();

            let redirectUrl = window.location.origin + "/";
            if (document.referrer && document.referrer.includes(window.location.origin)) {
              redirectUrl = document.referrer;
            }
            window.location.href = `${ssoEndpoint}/auth/logout?redirectUrl=${encodeURIComponent(redirectUrl)}`;
            return;
          }

          if (data && typeof data === "object" && !data.errorMessage) {
            dispatch(setUserDetails(data || {}));
            localStorage.setItem("user", JSON.stringify(data));
          }
        })
        .catch((err) => {
          console.error("Profile Page: Failed to fetch user details:", err);
        });
    } else if (!stored_access_token && !access_token) {
      // If totally unauthenticated, redirect home
      window.location.href = "/";
    }
  }, [dispatch, ssoEndpoint]);

  useEffect(() => {
    const userData = userdetails?.userData || userdetails || {};
    const userMetadata = userdetails?.metadata || {};

    const initEmail = userData?.emails?.[0] || userdetails?.email || "";
    setEmail(initEmail);
    setSavedEmail(initEmail);
    setEmailOtpVerified(true);

    const initFirstName = userMetadata?.first_name || "";
    setFirstName(initFirstName);
    setSavedName(initFirstName);
    setNameDone(true);

    setLastName(userMetadata?.last_name || "");
    setDisplayName(userMetadata?.displayName || "");
    setSavedDisplayName(userMetadata?.displayName || "");
    setDisplayNameDone(true);

    const rawMobile = userData?.phoneNumbers?.[0] || userdetails?.phoneNumber || "";
    let initMobile = rawMobile;
    if (initMobile.startsWith("+91")) {
      initMobile = initMobile.substring(3).trim();
    }
    setMobileNumber(initMobile);
    setSavedMobile(initMobile);
    setOtpVerified(true);

    setGender(userMetadata?.gender || "notDefined");
    if (userMetadata?.dob) {
      const initDob = new Date(userMetadata.dob.year, userMetadata.dob.month - 1, userMetadata.dob.day);
      setBirthDate(initDob);
      setSavedDob(initDob);
    }
  }, [userdetails]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsEpaperOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (window) {
      const url = window.location.href.split("?")[0];
      setRedirectUrl(url);
    }
  }, []);

  useEffect(() => {
    const userId = userdetails?.userData?.id || userdetails?.id;
    const userEmail = userdetails?.userData?.emails?.[0] || userdetails?.email;
    const userPhone = userdetails?.userData?.phoneNumbers?.[0] || userdetails?.phoneNumber;
    if (userId || userEmail || userPhone) {
      setIsLoading(false);
    }
  }, [userdetails]);

  const onDropdownBtnHandler = (value) => {
    if (value === isDropdownCollapsed) {
      setIsDropdownCollapsed("");
    } else {
      setIsDropdownCollapsed(value);
    }
  };

  // Name
  const handleUpdateName = (e) => {
    if (e) e.preventDefault();
    if (isNameUpdateDisabled) return;

    const trimmedFirstName = firstName.trim();
    setFirstName(trimmedFirstName);

    if (/\d/.test(trimmedFirstName)) {
      setNameError(true);
      setNameErrorMessage("Please enter a valid name.");
      return;
    }

    setIsUpdatingName(true);
    putUserDetails({ first_name: trimmedFirstName, last_name: lastName })
      .then((res) => {
        setIsUpdatingName(false);
        if (res && !res.errorMessage) {
          setSavedName(trimmedFirstName);
          setNameDone(true);
          const updatedUser = {
            ...userdetails,
            metadata: { ...userdetails?.metadata, first_name: trimmedFirstName, last_name: lastName }
          };
          dispatch(setUserDetails(updatedUser));
          if (typeof window !== "undefined") {
            window.localStorage.setItem("user", JSON.stringify(updatedUser));
            setTimeout(() => {
              window.dispatchEvent(
                new CustomEvent("show-snackbar", {
                  detail: { type: "success", message: "Name updated successfully!" }
                })
              );
            }, 100);
          }
        } else {
          setNameError(true);
          const isGoogleUser =
            userdetails?.metadata?.login_method === "google_login" || userdetails?.metadata?.login_method === "google";
          const errMsg = isGoogleUser
            ? "Name is not editable for Google login"
            : "Failed to update name. Please try again.";
          setNameErrorMessage(errMsg);
          if (typeof window !== "undefined") {
            setTimeout(() => {
              window.dispatchEvent(new CustomEvent("show-snackbar", { detail: { type: "failure", message: errMsg } }));
            }, 100);
          }
          console.error("[ProfilePage] handleUpdateName API Error:", res);
        }
      })
      .catch((err) => {
        setIsUpdatingName(false);
        setNameError(true);
        const isGoogleUser =
          userdetails?.metadata?.login_method === "google_login" || userdetails?.metadata?.login_method === "google";
        const errMsg = isGoogleUser
          ? "Name is not editable for Google login"
          : "Failed to update name. Please try again.";
        setNameErrorMessage(errMsg);
        if (typeof window !== "undefined") {
          setTimeout(() => {
            window.dispatchEvent(new CustomEvent("show-snackbar", { detail: { type: "failure", message: errMsg } }));
          }, 100);
        }
        console.error("[ProfilePage] handleUpdateName Catch Error:", err);
      });
  };

  const handleUpdateDisplayName = (e) => {
    if (e) e.preventDefault();
    if (isUpdatingDisplayName || displayName === savedDisplayName || displayName.trim().length === 0) return;
    setIsUpdatingDisplayName(true);

    // Send displayName flat at the root
    putUserDetails({ displayName: displayName }).then((res) => {
      setIsUpdatingDisplayName(false);
      if (res && !res.errorMessage) {
        setSavedDisplayName(displayName);
        setDisplayNameDone(true);
        const updatedUser = { ...userdetails, metadata: { ...userdetails?.metadata, displayName: displayName } };
        dispatch(setUserDetails(updatedUser));
        if (typeof window !== "undefined") {
          window.localStorage.setItem("user", JSON.stringify(updatedUser));
          setTimeout(() => {
            window.dispatchEvent(
              new CustomEvent("show-snackbar", {
                detail: { type: "success", message: "Display Name updated successfully!" }
              })
            );
          }, 100);
        }
      } else {
        if (typeof window !== "undefined") {
          setTimeout(() => {
            window.dispatchEvent(
              new CustomEvent("show-snackbar", {
                detail: { type: "failure", message: res?.errorMessage || "Failed to update Display Name. Please try again." }
              })
            );
          }, 100);
        }
        console.error("[ProfilePage] handleUpdateDisplayName API Error:", res);
      }
    }).catch((err) => {
      setIsUpdatingDisplayName(false);
      if (typeof window !== "undefined") {
        setTimeout(() => {
          window.dispatchEvent(
            new CustomEvent("show-snackbar", {
              detail: { type: "failure", message: "Failed to update Display Name. Please try again." }
            })
          );
        }, 100);
      }
      console.error("[ProfilePage] handleUpdateDisplayName Catch Error:", err);
    });
  };

  const handleGenderChange = (newGender) => {
    setGender(newGender);
    putUserDetails({ gender: newGender }).then(() => {
      const updatedUser = { ...userdetails, metadata: { ...userdetails?.metadata, gender: newGender } };
      dispatch(setUserDetails(updatedUser));
      if (typeof window !== "undefined") {
        window.localStorage.setItem("user", JSON.stringify(updatedUser));
        setTimeout(() => {
          window.dispatchEvent(
            new CustomEvent("show-snackbar", {
              detail: { type: "success", message: "Gender updated successfully!" }
            })
          );
        }, 100);
      }
    });
  };

  const handleUpdateDob = () => {
    if (birthDate && birthDate > new Date()) {
      setDobError(true);
      setDobErrorMessage("Invalid Date, Please select a Valid Date");
      return;
    }
    setDobError(false);
    setIsUpdatingDob(true);
    const dateValue = { year: birthDate.getFullYear(), month: birthDate.getMonth() + 1, day: birthDate.getDate() };
    putUserDetails({ dob: dateValue }).then(() => {
      const updatedUser = { ...userdetails, metadata: { ...userdetails?.metadata, dob: dateValue } };
      dispatch(setUserDetails(updatedUser));
      if (typeof window !== "undefined") {
        window.localStorage.setItem("user", JSON.stringify(updatedUser));
        setTimeout(() => {
          window.dispatchEvent(
            new CustomEvent("show-snackbar", {
              detail: { type: "success", message: "Date of Birth updated successfully!" }
            })
          );
        }, 100);
      }
      setSavedDob(birthDate);
      setDobDone(true);
      setIsUpdatingDob(false);
    }).catch(() => {
      setIsUpdatingDob(false);
    });
  };

  const handleEpaperChange = (edition) => {
    setSelectedEpaper(edition.name);
    setSelectedEpaperId(edition.id);

    // Update quintype profile (optional/legacy)
    putUserDetails({ epaper_edition: edition.name }).then(() => {
      const updatedUser = { ...userdetails, metadata: { ...userdetails?.metadata, epaper_edition: edition.name } };
      dispatch(setUserDetails(updatedUser));
      if (typeof window !== "undefined") {
        window.localStorage.setItem("user", JSON.stringify(updatedUser));
      }
    });

    // Update E-Paper specific preferences
    updateEpaperPreferences(edition.id)
      .then(() => {
        setTimeout(() => {
          window.dispatchEvent(
            new CustomEvent("show-snackbar", {
              detail: { type: "success", message: "Edition updated successfully!" }
            })
          );
        }, 100);
      })
      .catch(() => {
        setTimeout(() => {
          window.dispatchEvent(
            new CustomEvent("show-snackbar", { detail: { type: "failure", message: "Failed to update edition." } })
          );
        }, 100);
      });
  };

  // Mobile
  const handleMobileChange = (e) => {
    const val = e.target.value;
    setMobileNumber(val);
    if (mobileError) {
      setMobileError(false);
      setMobileErrorMessage("");
    }
    if (val === savedMobile && savedMobile) {
      setOtpVerified(true);
      setOtpSent(false);
    } else if (otpVerified) {
      setOtpVerified(false);
      setOtpSent(false);
    }
  };

  const handleSendOtp = (e) => {
    if (e) e.preventDefault();
    if (/^\d{10}$/.test(mobileNumber)) {
      sendChangePhoneOtp(`+91${mobileNumber}`, window.location.href)
        .then((res) => {
          if (res?.preAuthSessionId && res?.deviceId) {
            setAuthSessionInfo({ preAuthSessionId: res.preAuthSessionId, deviceId: res.deviceId });
            setOtpSent(true);
            setTimer(30);
            setOtpError(false);
            setMobileError(false);
          } else {
            setMobileError(true);
            const errMsg = res?.errorMessage || "";
            if (errMsg.toLowerCase().includes("exist")) {
              setMobileErrorMessage("User already exist with given Phone Number");
            } else {
              setMobileErrorMessage(errMsg || "Failed to send OTP.");
            }
          }
        })
        .catch((err) => {
          console.error("[ProfilePage] handleSendOtp Catch Error:", err);
          setMobileError(true);
          const errMsg = err?.errorMessage || "";
          if (errMsg.toLowerCase().includes("exist")) {
            setMobileErrorMessage("User already exist with given Phone Number");
          } else {
            setMobileErrorMessage(errMsg || "Failed to send OTP.");
          }
        });
    } else {
      setMobileError(true);
      setMobileErrorMessage("Enter a valid 10-digit indian mobile number");
    }
  };

  const handleResendOtp = (e) => {
    if (e) e.preventDefault();
    if (timer === 0) {
      sendChangePhoneOtp(`+91${mobileNumber}`, window.location.href).then((res) => {
        if (res?.preAuthSessionId && res?.deviceId) {
          setAuthSessionInfo({ preAuthSessionId: res.preAuthSessionId, deviceId: res.deviceId });
          setTimer(30);
          setOtpError(false);
        }
      });
    }
  };

  const handleVerifyOtp = (e) => {
    if (e) e.preventDefault();
    if (isVerifying || otpValue.length !== 6) return;
    setIsVerifying(true);

    verifySsoCode(authSessionInfo.preAuthSessionId, authSessionInfo.deviceId, otpValue)
      .then((res) => {
        setIsVerifying(false);
        if (res?.status === "OK") {
          setOtpError(false);
          setOtpVerified(true);
          setSavedMobile(mobileNumber);
          setOtpSent(false);
          const updatedUser = {
            ...userdetails,
            userData: { ...userdetails?.userData, phoneNumbers: [`+91${mobileNumber}`] }
          };
          dispatch(setUserDetails(updatedUser));
          if (typeof window !== "undefined") {
            window.localStorage.setItem("user", JSON.stringify(updatedUser));
            setTimeout(() => {
              window.dispatchEvent(
                new CustomEvent("show-snackbar", {
                  detail: { type: "success", message: "Mobile Number updated successfully." }
                })
              );
            }, 100);
          }
        } else {
          console.error("[ProfilePage] handleVerifyOtp API Error:", res);
          setOtpError(true);
        }
      })
      .catch((err) => {
        console.error("[ProfilePage] handleVerifyOtp Catch Error:", err);
        setIsVerifying(false);
        setOtpError(true);
      });
  };

  // Email
  const handleEmailChange = (e) => {
    const val = e.target.value;
    setEmail(val);
    if (emailError) {
      setEmailError(false);
      setEmailErrorMessage("");
    }
    if (val === savedEmail && savedEmail) {
      setEmailOtpVerified(true);
      setEmailOtpSent(false);
    } else if (emailOtpVerified) {
      setEmailOtpVerified(false);
      setEmailOtpSent(false);
    }
  };

  const handleSendEmailOtp = (e) => {
    if (e) e.preventDefault();
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      sendChangeEmailOtp(email, window.location.href)
        .then((res) => {
          if (res?.preAuthSessionId) {
            setAuthSessionInfo({ preAuthSessionId: res.preAuthSessionId, deviceId: res.deviceId });
            setEmailOtpSent(true);
            setEmailTimer(30);
            setEmailOtpError(false);
            setEmailError(false);
          } else {
            setEmailError(true);
            const errMsg = res?.errorMessage || "";
            if (errMsg.toLowerCase().includes("exist")) {
              setEmailErrorMessage("User already exist with given Email ID.");
            } else {
              setEmailErrorMessage(errMsg || "Failed to send OTP.");
            }
          }
        })
        .catch((err) => {
          console.error("[ProfilePage] handleSendEmailOtp Catch Error:", err);
          setEmailError(true);
          const errMsg = err?.errorMessage || "";
          if (errMsg.toLowerCase().includes("exist")) {
            setEmailErrorMessage("User already exist with given Email ID.");
          } else {
            setEmailErrorMessage(errMsg || "Failed to send OTP.");
          }
        });
    } else {
      setEmailError(true);
      setEmailErrorMessage("Invalid email address.");
    }
  };

  const handleResendEmailOtp = (e) => {
    if (e) e.preventDefault();
    if (emailTimer === 0) {
      sendChangeEmailOtp(email, window.location.href).then((res) => {
        if (res?.preAuthSessionId) {
          setAuthSessionInfo({ preAuthSessionId: res.preAuthSessionId, deviceId: res.deviceId });
          setEmailTimer(30);
          setEmailOtpError(false);
        }
      });
    }
  };

  const handleVerifyEmailOtp = (e) => {
    if (e) e.preventDefault();
    if (isVerifyingEmail || emailOtpValue.length !== 6) return;
    setIsVerifyingEmail(true);

    verifySsoCode(authSessionInfo.preAuthSessionId, authSessionInfo.deviceId, emailOtpValue)
      .then((res) => {
        setIsVerifyingEmail(false);
        if (res?.status === "OK") {
          setEmailOtpError(false);
          setEmailOtpVerified(true);
          setSavedEmail(email);
          setEmailOtpSent(false);
          const updatedUser = { ...userdetails, userData: { ...userdetails?.userData, emails: [email] } };
          dispatch(setUserDetails(updatedUser));
          if (typeof window !== "undefined") {
            window.localStorage.setItem("user", JSON.stringify(updatedUser));
            setTimeout(() => {
              window.dispatchEvent(
                new CustomEvent("show-snackbar", {
                  detail: { type: "success", message: "Email ID updated successfully." }
                })
              );
            }, 100);
          }
        } else {
          console.error("[ProfilePage] handleVerifyEmailOtp API Error:", res);
          setEmailOtpError(true);
        }
      })
      .catch((err) => {
        console.error("[ProfilePage] handleVerifyEmailOtp Catch Error:", err);
        setIsVerifyingEmail(false);
        setEmailOtpError(true);
      });
  };

  const logoutHandler = () => {
    if (typeof window !== "undefined") {
      window.logoutInProgress = true;
    }
    addLogoutToDataLayer(window.location.href, userdetails);
    window.localStorage.removeItem("user");
    window.localStorage.removeItem("access_token");
    window.localStorage.removeItem("refresh_token");
    localStorage.removeItem("commentsToken");
    localStorage.removeItem("last_logged_in_uuid");
    document.cookie = "qt-auth=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Secure; SameSite=Lax";
    clearAuthCookies();
    localStorage.setItem("isProfileOpen", "false");
    googleLogout();
    dispatch(setIsLogin(false));
    dispatch(setUserDetails(null));
    let redirectUrl = window.location.origin + "/";
    const urlParams = new URLSearchParams(window.location.search);
    const returnUrl = urlParams.get("returnUrl");
    sessionStorage.removeItem(PAYMENT_PROCESSING_STATE_KEY);
    sessionStorage.removeItem(SHOW_SUPPORT_STRIP_ON_REDIRECT_KEY);

    if (returnUrl) {
      redirectUrl = returnUrl;
    } else if (document.referrer && document.referrer.includes(window.location.origin)) {
      redirectUrl = document.referrer;
    } else {
      console.log("ProfilePage: No returnUrl or referrer, defaulting to home", redirectUrl);
    }

    setTimeout(() => {
      window.location.search = "";
      window.location.href = `${ssoEndpoint}/auth/logout?redirectUrl=${encodeURIComponent(redirectUrl)}`;
    }, 300);
  };

  const handleGoBack = () => {
    if (window.history.length > 2) {
      window.history.back();
    } else {
      window.location.href = "/";
    }
  };
  if (isLoading)
    return (
      <div styleName="loading-animation">
        <div styleName="loading-animation__circle"></div>
      </div>
    );
  return (
    <div styleName="my-account-wrapper">
      <div styleName="top-section">
        <div styleName="close-btn-wrapper" onClick={handleGoBack}>
          <Arrow color="black" width="16px" height="16px" />
        </div>
        <span styleName="title-text">ನನ್ನ ಮಾಹಿತಿ</span>
      </div>
      <div styleName="second-section">
        <div styleName="button-container">
          <button styleName={`tab-btn ${selectedButton === 1 ? "active" : ""}`} onClick={() => setSelectedButton(1)}>
            ವೈಯಕ್ತಿಕ ಮಾಹಿತಿ
          </button>
          <button styleName={`tab-btn ${selectedButton === 2 ? "active" : ""}`} onClick={() => setSelectedButton(2)}>
            ಚಂದಾದಾರಿಕೆ
          </button>
        </div>
        {selectedButton === 1 && (
          <>
            <div
              styleName="info-container"
              style={{ borderBottom: nameDone ? "" : "none" }}
            >
              <div styleName="info-left">
                <div styleName="info-left-top">
                  <span className="hide-mobile" styleName="desktop-svg">
                    <User height="16" width="16" color="#999" />
                  </span>
                  ಹೆಸರು
                </div>
                <div
                  styleName="info-left-bottom"
                  style={{ width: "100%", minHeight: "24px", cursor: (nameDone && !isGoogleUser) ? "pointer" : "default" }}
                  onClick={() => {
                    if (nameDone) {
                      if (isGoogleUser) {
                        if (typeof window !== "undefined") {
                          setTimeout(() => {
                            window.dispatchEvent(new CustomEvent("show-snackbar", { detail: { type: "failure", message: "Name is not editable for Google login" } }));
                          }, 100);
                        }
                      } else {
                        setNameDone(false);
                        setTimeout(() => document.getElementById('nameInput')?.focus(), 0);
                      }
                    }
                  }}
                >
                  {nameDone ? (
                    `${userdetails?.metadata?.first_name || ""} ${userdetails?.metadata?.last_name || ""}`.trim()
                  ) : (
                    <>
                      <div className="inputGroup">
                        <input
                          id="nameInput"
                          type="text"
                          value={firstName}
                          onChange={(e) => {
                            setFirstName(e.target.value);
                            if (nameError) {
                              setNameError(false);
                              setNameErrorMessage("");
                            }
                            if (nameDone) setNameDone(false);
                          }}
                          onBlur={handleNameBlur}
                          autoFocus
                          styleName="edit-input"
                        />
                        <div styleName={nameError ? "editInputUnderlineError" : "editInputUnderline"} />
                      </div>
                      {nameError && (
                        <div styleName="errorMessage" style={{ marginTop: "5px" }}>
                          {nameErrorMessage}
                        </div>
                      )}
                      {firstName.trim().length > 0 && !nameDone && (
                        <div styleName="otpButtonContainer" style={{ paddingTop: "9px", marginTop: "0" }}>
                          <button
                            styleName={
                              isNameUpdateDisabled
                                ? "nameDoneBtnDisabled"
                                : isUpdatingName
                                  ? "nameDoneBtnLoading"
                                  : "nameDoneBtn"
                            }
                            onClick={handleUpdateName}
                            disabled={isNameUpdateDisabled}
                          >
                            {isUpdatingName ? (
                              <>
                                <SpinnerIcon styleName="spinner" />
                                ನವೀಕರಿಸಲಾಗುತ್ತಿದೆ
                              </>
                            ) : (
                              "ನವೀಕರಿಸಿ"
                            )}
                          </button>
                          <button
                            styleName="nameCancelBtn"
                            onClick={() => {
                              setFirstName(savedName || "");
                              setNameDone(true);
                            }}
                          >
                            ರದ್ದು
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div
                styleName="info-right"
                onClick={() => {
                  if (isGoogleUser) {
                    if (typeof window !== "undefined") {
                      setTimeout(() => {
                        window.dispatchEvent(new CustomEvent("show-snackbar", { detail: { type: "failure", message: "Name is not editable when logged in via Google." } }));
                      }, 100);
                    }
                  } else {
                    setNameDone(false);
                    setTimeout(() => document.getElementById('nameInput')?.focus(), 0);
                  }
                }}
                style={{ cursor: isGoogleUser ? "default" : "pointer" }}
              >
                <EditIcon />
              </div>
            </div>
            <div
              styleName="info-container"
              style={{ borderBottom: otpVerified ? "" : "none" }}
            >
              <div styleName="info-left">
                <div styleName="info-left-top">
                  <span className="hide-mobile" styleName="desktop-svg">
                    <PhoneIcon />
                  </span>
                  ಮೊಬೈಲ್ ಸಂಖ್ಯೆ
                </div>
                <div styleName="info-left-bottom" style={{ width: "100%", minHeight: "24px", cursor: otpVerified ? "pointer" : "default" }} onClick={() => {
                  if (otpVerified) {
                    setOtpVerified(false);
                    setTimeout(() => document.getElementById('mobileInput')?.focus(), 0);
                  }
                }}>
                  {otpVerified ? (
                    formatPhoneNumber(userdetails?.userData?.phoneNumbers?.[0])
                  ) : (
                    <>
                      <div className="inputGroup">
                        <div styleName="mobileInputRow">
                          {mobileNumber.length > 0 && <div styleName="countryCodeBadge">+91</div>}
                          <input
                            id="mobileInput"
                            type="tel"
                            value={mobileNumber}
                            onChange={handleMobileChange}
                            onBlur={handleMobileBlur}
                            autoFocus
                            styleName="edit-input"
                          />
                        </div>
                        <div styleName={mobileError ? "editInputUnderlineError" : "editInputUnderline"} />
                      </div>
                      {mobileError && !otpSent && (
                        <div styleName="errorMessage" style={{ marginTop: "5px" }}>
                          {mobileErrorMessage}
                        </div>
                      )}
                      {mobileNumber.length > 0 && !otpVerified && (
                        <div>
                          {otpSent && (
                            <div styleName="otpInputWrapper">
                              <input
                                type="text"
                                autoFocus={true}
                                styleName="inputField otpInputField"
                                placeholder="ಒಟಿಪಿ ದಾಖಲಿಸಿ"
                                value={otpValue}
                                maxLength={6}
                                onChange={(e) => setOtpValue(e.target.value)}
                              />
                              <div styleName="inputUnderline" />
                            </div>
                          )}
                          {otpError && <div styleName="errorMessage">Incorrect OTP. Please try again.</div>}
                          <div
                            styleName="otpButtonContainer"
                            style={{ marginTop: mobileError || otpError ? "0" : "9px" }}
                          >
                            <button
                              styleName={
                                otpSent
                                  ? isVerifying
                                    ? "otpVerifyBtnLoading"
                                    : otpValue.length !== 6
                                      ? "otpVerifyBtnDisabled"
                                      : "otpVerifyBtn"
                                  : isSendOtpDisabled
                                    ? "otpResendBtnDisabled"
                                    : "otpResendBtn"
                              }
                              onClick={otpSent ? handleVerifyOtp : handleSendOtp}
                              disabled={otpSent ? isVerifying || otpValue.length !== 6 : isSendOtpDisabled}
                            >
                              {otpSent ? (
                                isVerifying ? (
                                  <>
                                    <SpinnerIcon styleName="spinner" />
                                    ಪರಿಶೀಲಿಸಲಾಗುತ್ತಿದೆ
                                  </>
                                ) : (
                                  "ಪೂರ್ಣಗೊಳಿಸಿ"
                                )
                              ) : (
                                "ಪೂರ್ಣಗೊಳಿಸಿ"
                              )}
                            </button>
                            <button
                              styleName="otpCancelBtn"
                              onClick={() => {
                                setMobileNumber(savedMobile || "");
                                setOtpSent(false);
                                setOtpVerified(!!savedMobile);
                                setTimer(30);
                                setOtpValue("");
                                setOtpError(false);
                                setMobileError(false);
                              }}
                            >
                              ರದ್ದು
                            </button>
                          </div>

                          {otpSent && (
                            <div styleName="resendContainer">
                              {timer > 0 ? (
                                <div styleName="resendBlock">
                                  <span styleName="resendTextDisabled">ಒಟಿಪಿ ಮತ್ತೊಮ್ಮೆ ಕಳುಹಿಸಿ</span>
                                  <div styleName="timerWrapper">
                                    <TimerIcon />
                                    <span styleName="timerCount">{timer}</span>
                                  </div>
                                </div>
                              ) : (
                                <span styleName="resendTextActive" onClick={handleResendOtp}>
                                  ಒಟಿಪಿ ಮತ್ತೊಮ್ಮೆ ಕಳುಹಿಸಿ
                                </span>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div styleName="info-right" onClick={() => {
                setOtpVerified(false);
                setTimeout(() => document.getElementById('mobileInput')?.focus(), 0);
              }} style={{ cursor: "pointer" }}>
                <EditIcon />
              </div>
            </div>
            <div
              styleName="info-container"
              style={{
                borderBottom: emailOtpVerified ? "" : "none"
              }}
            >
              <div styleName="info-left">
                <div styleName="info-left-top">
                  <span className="hide-mobile" styleName="desktop-svg">
                    <MailIcon />
                  </span>
                  ಇಮೇಲ್‌ ವಿಳಾಸ
                </div>
                <div
                  styleName="info-left-bottom"
                  style={{ width: "100%", minHeight: "24px", cursor: (emailOtpVerified && !isGoogleUser) ? "pointer" : "default" }}
                  onClick={() => {
                    if (emailOtpVerified) {
                      if (isGoogleUser) {
                        if (typeof window !== "undefined") {
                          setTimeout(() => {
                            window.dispatchEvent(new CustomEvent("show-snackbar", { detail: { type: "failure", message: "Email ID is not editable when logged in via Google." } }));
                          }, 100);
                        }
                      } else {
                        setEmailOtpVerified(false);
                        setTimeout(() => document.getElementById('emailInput')?.focus(), 0);
                      }
                    }
                  }}
                >
                  {emailOtpVerified ? (
                    userdetails?.userData?.emails?.[0]
                  ) : (
                    <>
                      <div className="inputGroup">
                        <input
                          id="emailInput"
                          type="email"
                          value={email}
                          onChange={handleEmailChange}
                          onBlur={handleEmailBlur}
                          autoFocus
                          styleName="edit-input"
                        />
                        <div styleName={emailError ? "editInputUnderlineError" : "editInputUnderline"} />
                      </div>
                      {emailError && !emailOtpSent && (
                        <div styleName="errorMessage" style={{ marginTop: "5px" }}>
                          {emailErrorMessage}
                        </div>
                      )}
                      {email.length > 0 && !emailOtpVerified && (
                        <div>
                          {emailOtpSent && (
                            <div styleName="otpInputWrapper">
                              <input
                                type="text"
                                autoFocus={true}
                                styleName="inputField otpInputField"
                                placeholder="ಒಟಿಪಿ ದಾಖಲಿಸಿ"
                                value={emailOtpValue}
                                maxLength={6}
                                onChange={(e) => setEmailOtpValue(e.target.value)}
                              />
                              <div styleName="inputUnderline" />
                            </div>
                          )}
                          {emailOtpError && <div styleName="errorMessage">Incorrect OTP. Please try again.</div>}
                          <div
                            styleName="otpButtonContainer"
                            style={{ marginTop: emailError || emailOtpError ? "0" : "9px" }}
                          >
                            <button
                              styleName={
                                emailOtpSent
                                  ? isVerifyingEmail
                                    ? "otpVerifyBtnLoading"
                                    : emailOtpValue.length !== 6
                                      ? "otpVerifyBtnDisabled"
                                      : "otpVerifyBtn"
                                  : isSendEmailOtpDisabled
                                    ? "otpResendBtnDisabled"
                                    : "otpResendBtn"
                              }
                              onClick={emailOtpSent ? handleVerifyEmailOtp : handleSendEmailOtp}
                              disabled={
                                emailOtpSent ? isVerifyingEmail || emailOtpValue.length !== 6 : isSendEmailOtpDisabled
                              }
                            >
                              {emailOtpSent ? (
                                isVerifyingEmail ? (
                                  <>
                                    <SpinnerIcon styleName="spinner" />
                                    ಪರಿಶೀಲಿಸಲಾಗುತ್ತಿದೆ
                                  </>
                                ) : (
                                  "ಪೂರ್ಣಗೊಳಿಸಿ"
                                )
                              ) : (
                                "ಪೂರ್ಣಗೊಳಿಸಿ"
                              )}
                            </button>
                            <button
                              styleName="otpCancelBtn"
                              onClick={() => {
                                setEmail(savedEmail || "");
                                setEmailOtpSent(false);
                                setEmailOtpVerified(!!savedEmail);
                                setEmailTimer(30);
                                setEmailOtpValue("");
                                setEmailOtpError(false);
                                setEmailError(false);
                              }}
                            >
                              ರದ್ದು
                            </button>
                          </div>

                          {emailOtpSent && (
                            <div styleName="resendContainer">
                              {emailTimer > 0 ? (
                                <div styleName="resendBlock">
                                  <span styleName="resendTextDisabled">ಒಟಿಪಿ ಮತ್ತೊಮ್ಮೆ ಕಳುಹಿಸಿ</span>
                                  <div styleName="timerWrapper">
                                    <TimerIcon />
                                    <span styleName="timerCount">{emailTimer}</span>
                                  </div>
                                </div>
                              ) : (
                                <span styleName="resendTextActive" onClick={handleResendEmailOtp}>
                                  ಒಟಿಪಿ ಮತ್ತೊಮ್ಮೆ ಕಳುಹಿಸಿ
                                </span>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div
                styleName="info-right"
                onClick={() => {
                  if (isGoogleUser) {
                    if (typeof window !== "undefined") {
                      window.dispatchEvent(new CustomEvent("show-snackbar", { detail: { type: "failure", message: "Email ID is not editable when logged in via Google." } }));
                    }
                  } else {
                    setEmailOtpVerified(false);
                    setTimeout(() => document.getElementById('emailInput')?.focus(), 0);
                  }
                }}
                style={{ cursor: isGoogleUser ? "default" : "pointer" }}
              >
                <EditIcon />
              </div>
            </div>
            <div
              styleName="info-container"
              style={{ borderBottom: displayNameDone ? "" : "none" }}
            >
              <div styleName="info-left">
                <div styleName="info-left-top">
                  <span className="hide-mobile" styleName="desktop-svg">
                    <NewUserIcon />
                  </span>
                  ಪ್ರದರ್ಶಿಸಬಹುದಾದ ಹೆಸರು
                </div>
                <div styleName="info-left-bottom" style={{ width: "100%", minHeight: "24px", cursor: displayNameDone ? "pointer" : "default" }} onClick={() => {
                  if (displayNameDone) setDisplayNameDone(false);
                  setTimeout(() => document.getElementById('displayNameInput')?.focus(), 0);
                }}>
                  {displayNameDone ? (
                    savedDisplayName
                  ) : (
                    <>
                      <div className="inputGroup">
                        <input
                          id="displayNameInput"
                          type="text"
                          value={displayName}
                          autoFocus={true}
                          onChange={(e) => {
                            setDisplayName(e.target.value);
                            if (displayNameDone) setDisplayNameDone(false);
                          }}
                          styleName="edit-input"
                        />
                        <div styleName="editInputUnderline" />
                      </div>
                      {displayName.trim().length > 0 && !displayNameDone && (
                        <div styleName="otpButtonContainer" style={{ paddingTop: "9px", marginTop: "0" }}>
                          <button
                            styleName={
                              displayName === savedDisplayName || displayName.trim().length === 0
                                ? "nameDoneBtnDisabled"
                                : isUpdatingDisplayName
                                  ? "nameDoneBtnLoading"
                                  : "nameDoneBtn"
                            }
                            onClick={handleUpdateDisplayName}
                            disabled={displayName === savedDisplayName || displayName.trim().length === 0}
                          >
                            {isUpdatingDisplayName ? (
                              <>
                                <SpinnerIcon styleName="spinner" />
                                ನವೀಕರಿಸಲಾಗುತ್ತಿದೆ
                              </>
                            ) : (
                              "ನವೀಕರಿಸಿ"
                            )}
                          </button>
                          <button
                            styleName="nameCancelBtn"
                            onClick={() => {
                              setDisplayName(savedDisplayName || "");
                              setDisplayNameDone(true);
                            }}
                          >
                            ರದ್ದು
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div styleName="info-right" onClick={() => {
                setDisplayNameDone(false);
                setTimeout(() => document.getElementById('displayNameInput')?.focus(), 0);
              }} style={{ cursor: "pointer" }}>
                <EditIcon />
              </div>
            </div>
            <div styleName="info-container" style={{ borderBottom: dobDone ? "" : "none" }}>
              <div styleName="info-left">
                <div styleName="info-left-top">
                  <span className="hide-mobile" styleName="desktop-svg">
                    <EmptyCalenderIcon />
                  </span>
                  ಜನ್ಮ ದಿನಾಂಕ
                </div>
                <div styleName="info-left-bottom" style={{ width: "100%", cursor: "pointer" }}>
                  <div onClick={() => setIsCalendarOpen(true)} style={{ minHeight: "24px", borderBottom: dobError ? "1px solid #B82831" : "" }}>
                    {birthDate ? birthDate.toLocaleDateString("en-IN") : ""}
                  </div>
                  {dobError && <div styleName="errorMessage" style={{ marginTop: "5px" }}>{dobErrorMessage}</div>}
                  {!dobDone && (
                    <div styleName="otpButtonContainer" style={{ paddingTop: "9px", marginTop: "0" }}>
                      <button
                        styleName={isUpdatingDob ? "nameDoneBtnLoading" : "nameDoneBtn"}
                        onClick={handleUpdateDob}
                        disabled={isUpdatingDob}
                      >
                        {isUpdatingDob ? (
                          <>
                            <SpinnerIcon styleName="spinner" />
                            ನವೀಕರಿಸಲಾಗುತ್ತಿದೆ
                          </>
                        ) : (
                          "ನವೀಕರಿಸಿ"
                        )}
                      </button>
                      <button
                        styleName="nameCancelBtn"
                        onClick={() => {
                          setBirthDate(savedDob);
                          setDobError(false);
                          setDobDone(true);
                        }}
                      >
                        ರದ್ದು
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div styleName="info-right" onClick={() => setIsCalendarOpen(true)} style={{ cursor: "pointer" }}>
                <span style={{ height: "18px" }}>
                  <Calender width="18px" height="18px" color="#B82831" />
                </span>
              </div>
              <BirthDatePicker
                isOpen={isCalendarOpen}
                onClose={() => setIsCalendarOpen(false)}
                birthDate={birthDate}
                setBirthDate={(date) => {
                  setBirthDate(date);
                  setDobError(false);
                  setDobDone(false);
                }}
              />
            </div>
            <div styleName="info-container">
              <div styleName="info-left">
                <div styleName="info-left-top">
                  <span className="hide-mobile" styleName="desktop-svg">
                    <GenderIcon />
                  </span>
                  ಲಿಂಗ
                </div>
                <div styleName="info-left-bottom">
                  <div styleName="radio-group">
                    <label styleName="radio-item" onClick={() => handleGenderChange("male")}>
                      <input
                        type="radio"
                        name="gender"
                        value="male"
                        checked={gender === "male"}
                        onChange={() => handleGenderChange("male")}
                        styleName="radio-input"
                      />
                      <span styleName="radio-circle" />
                      <span>ಪುರುಷ</span>
                    </label>

                    <label styleName="radio-item" onClick={() => handleGenderChange("female")}>
                      <input
                        type="radio"
                        name="gender"
                        value="female"
                        checked={gender === "female"}
                        onChange={() => handleGenderChange("female")}
                        styleName="radio-input"
                      />
                      <span styleName="radio-circle" />
                      <span>ಮಹಿಳೆಯರು</span>
                    </label>

                    <label styleName="radio-item" onClick={() => handleGenderChange("notDefined")}>
                      <input
                        type="radio"
                        name="gender"
                        value="notDefined"
                        checked={gender === "notDefined"}
                        onChange={() => handleGenderChange("notDefined")}
                        styleName="radio-input"
                      />
                      <span styleName="radio-circle" />
                      <span>ಹೇಳದಿರಲು ಆದ್ಯತೆ</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div styleName="info-container" style={{ borderBottom: isEpaperOpen ? "none" : "" }}>
              <div styleName="info-left">
                <div styleName="info-left-top">
                  <span className="hide-mobile" styleName="desktop-svg">
                    <LocationPinIcon height="20" width="16" />
                  </span>
                  ನಿಮ್ಮ ಆಯ್ಕೆಯ ಇ–ಪೇಪರ್ ಆವೃತ್ತಿ
                </div>
                <div styleName={`info-left-bottom ${isEpaperOpen ? "spcl-border" : ""}`}>
                  <div styleName="custom-dropdown" ref={dropdownRef}>
                    <div styleName="dropdown-header" onClick={() => setIsEpaperOpen(true)}>
                      <span>{selectedEpaper}</span>
                      {!isEpaperOpen ? <FillDownArrow height="13px" width="13px" color="#B82831" /> : <CityIcon />}
                    </div>
                    {isEpaperOpen && (
                      <div styleName="edition-overlay" onClick={() => setIsEpaperOpen(false)}>
                        <div styleName="edition-modal" onClick={(e) => e.stopPropagation()}>
                          <div styleName="edition-header">
                            <span>Select Edition</span>
                            <button styleName="close-btn" onClick={() => setIsEpaperOpen(false)}>
                              <Close height="10px" width="10px" color="black" />
                            </button>
                          </div>
                          <div styleName="edition-divider" />
                          <div styleName="edition-state">Karnataka</div>
                          <div styleName="edition-list">
                            {isEpaperLoading ? (
                              <div styleName="edition-item">Loading editions...</div>
                            ) : (
                              editionList.map((edition) => (
                                <div
                                  key={edition.id}
                                  styleName={`edition-item ${selectedEpaperId === edition.id ? "selected" : ""}`}
                                  onClick={() => {
                                    handleEpaperChange(edition);
                                    setIsEpaperOpen(false);
                                  }}
                                >
                                  <div styleName="edition-left">
                                    <LocationPinIcon />
                                    <span>{edition.name}</span>
                                  </div>
                                  {selectedEpaperId === edition.id && (
                                    <span styleName="checkmark">
                                      <TickIcon />
                                    </span>
                                  )}
                                </div>
                              ))
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {selectedButton === 2 && (
          <div styleName="tabContent">
            <MySubscription />
          </div>
        )}
        <div styleName="logoutWrapper">
          <button
            styleName="logout-button"
            onClick={() => {
              logoutHandler();
            }}
          >
            ಲಾಗ್‌ಔಟ್‌
          </button>
        </div>
      </div>
      <Snackbar />
    </div>
  );
};

export { ProfilePage };
